import React, { useState, useEffect } from 'react';
import {
  ButtonHLPure,
  CheckBoxHLPure,
  TooltipHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from '../../../pures';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { profileIconDefault } from '../../../../assets/logos/icons';
import './user-administration-role-assign.view.css';

const UserAdministrationRoleAssignView = ({
  hideShowDetails,
  selectedUser,
  token,
  rolesBySignatureProfile,
  rolesByEmailUser,
  saveRolesAndProfilesForUser,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  emailAdmin,
  toggleCompleteCloseDialog
}) => {
  const [checkedSuperAdministrator, setCheckedSuperAdministrator] =
    useState(false);
  const [checkedStateHelpDesk, setCheckedStateHelpDesk] = useState();
  const [checkedStateContrato, setCheckedStateContrato] = useState();
  const [checkedStateBoveda, setCheckedStateBoveda] = useState();
  const [checkedStateProfiles, setCheckedStateProfiles] = useState();
  const [checkedStateProfilesOrg, setCheckedStateProfilesOrg] = useState();
  const [checkboxDisabled, setCheckboxDisabled] = useState(
    checkedSuperAdministrator
  );
  const { t } = useTranslation();

  useEffect(() => {
    if (!rolesByEmailUser || !rolesByEmailUser.roleHibou) return;
    const isChecked = rolesByEmailUser?.roleHibou.id === 5;
    setCheckedSuperAdministrator(isChecked);
    setCheckboxDisabled(isChecked);
  }, [rolesByEmailUser]);

  const setDefaultCheckedValuesContrato = () => {
    let finalArrContrato = [];
    rolesBySignatureProfile.rolesContrato
      .sort((a, b) => {
        return a.id - b.id;
      })
      .map((rolContrato) => {
        let rolContratNameDefault = (
          (rolesByEmailUser || {}).roleContract || {}
        ).name;
        return finalArrContrato.push({
          name: rolContrato.name,
          checkedValue:
            rolContratNameDefault === rolContrato.name ? true : false,
          id: rolContrato.id,
          key: rolContrato.key,
        });
      });
    setCheckedStateContrato(finalArrContrato);
  };

  const setDefaultCheckedValuesHelpDesk = () => {
    let finalArrHelpDesk = [];
    rolesBySignatureProfile.rolesHelpDesk
      .sort((a, b) => {
        return a.id - b.id;
      })
      .map((rolHelpDesk) => {
        let rolContratNameDefault = (
          (rolesByEmailUser || {}).roleHelpDesk || {}
        ).name;
        return finalArrHelpDesk.push({
          name: rolHelpDesk.name,
          checkedValue:
            rolContratNameDefault === rolHelpDesk.name ? true : false,
          id: rolHelpDesk.id,
          key: rolHelpDesk.key,
        });
      });
    setCheckedStateHelpDesk(finalArrHelpDesk);
  };

  const setDefaultCheckedValuesBoveda = () => {
    let finalArrBoveda = [];
    rolesBySignatureProfile.rolesBoveda.map((rolBoveda) => {
      let rolBovedaNameDefault = ((rolesByEmailUser || {}).roleBoveda || {})
        .name;
      return finalArrBoveda.push({
        name: rolBoveda.name,
        checkedValue: rolBovedaNameDefault === rolBoveda.name ? true : false,
        id: rolBoveda.id,
        key: rolBoveda.key,
      });
    });
    setCheckedStateBoveda(finalArrBoveda);
  };

  const setDefaultCheckedValuesSignatureProfile = () => {
    let finalArrProfile = [];
    rolesBySignatureProfile.signaturesProfile.map((profile) => {
      return finalArrProfile.push({
        name: profile.name,
        checkedValue:
          rolesByEmailUser.signaturerProfiles
            ?.map(function (roleProfile) {
              return roleProfile?.signatureProfile.name === profile.name
                ? true
                : false;
            })
            .filter((value) => (value ? value : false))[0] ?? false,
        id: profile.id,
      });
    });
    setCheckedStateProfiles(finalArrProfile);
    setCheckedStateProfilesOrg(finalArrProfile);
  };

  useEffect(() => {
    if (rolesByEmailUser && rolesBySignatureProfile) {
      setDefaultCheckedValuesSignatureProfile();
      setDefaultCheckedValuesBoveda();
      setDefaultCheckedValuesContrato();
      setDefaultCheckedValuesHelpDesk();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesByEmailUser, rolesBySignatureProfile]);

  const handleCheckedSuperAdministrator = (e) => {
    setCheckedSuperAdministrator(e.target.checked);
    setCheckboxDisabled(e.target.checked);
    let arrBovedaCopy = [...checkedStateBoveda];
    let arrContratoCopy = [...checkedStateContrato];
    let arrHelpDeskCopy = [...checkedStateHelpDesk];
    arrBovedaCopy.map((item) => (item.checkedValue = false));
    arrContratoCopy.map((item) => (item.checkedValue = false));
    arrHelpDeskCopy.map((item) => (item.checkedValue = false));
  };

  const handleContratoCheckedState = (itemContrato, e) => {
    const { checked } = e.target;
    let arrContratoCopy = [...checkedStateContrato];
    let itemIndex = arrContratoCopy.findIndex(
      (item) => item.key === itemContrato.key
    );
    arrContratoCopy.map((item) => (item.checkedValue = false));
    arrContratoCopy[itemIndex].checkedValue = checked;
    setCheckedStateContrato(arrContratoCopy);
  };

  const handleHelpDeskCheckedState = (itemHelpDesk, e) => {
    const { checked } = e.target;
    let arrHelpDeskCopy = [...checkedStateHelpDesk];
    let itemIndex = arrHelpDeskCopy.findIndex(
      (item) => item.key === itemHelpDesk.key
    );
    arrHelpDeskCopy.map((item) => (item.checkedValue = false));
    arrHelpDeskCopy[itemIndex].checkedValue = checked;
    setCheckedStateHelpDesk(arrHelpDeskCopy);
  };

  const handleBovedaCheckedState = (itemBoveda, e) => {
    const { checked } = e.target;
    let arrBovedaCopy = [...checkedStateBoveda];
    let itemIndex = arrBovedaCopy.findIndex(
      (item) => item.key === itemBoveda.key
    );
    arrBovedaCopy.map((item) => (item.checkedValue = false));
    arrBovedaCopy[itemIndex].checkedValue = checked;
    setCheckedStateBoveda(arrBovedaCopy);
  };

  const handleProfileCheckedState = (position) => {
    const updatedProfileCheckedState = checkedStateProfiles.map(
      (profile, index) =>
        index === position
          ? { ...profile, checkedValue: !profile.checkedValue }
          : { ...profile }
    );
    setCheckedStateProfiles(updatedProfileCheckedState);
  };

  const handleSaveRolesAndProfilesData = () => {
    const selectedRoles = [];
    if (checkedSuperAdministrator) {
      selectedRoles.push({
        role: 'hibouBasic',
        key: process.env.REACT_APP_ADMIN,
      });
    } else {
      selectedRoles.push({
        role: 'hibouBasic',
        key: process.env.REACT_APP_COLABORATOR,
      });
    }
    const selectedContractId = checkedStateContrato
      .filter((contract) => contract.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouDigitalContract', key: obj.key }
            : { role: 'hibouDigitalContract', key: defaultValue },
        {
          role: 'hibouDigitalContract',
          key: process.env.REACT_APP_NOT_ACCESS_DIGITAL_CONTRACT,
        }
      );

    const selectedBovedaId = checkedStateBoveda
      .filter((boveda) => boveda.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouDigitalVault', key: obj.key, id: obj.id }
            : { role: 'hibouDigitalVault', key: defaultValue, id: obj.id },
        {
          role: 'hibouDigitalVault',
          key: process.env.REACT_APP_NOT_ACCESS_DIGITAL_VAULT,
        }
      );

    const selectedHelpDeskId = checkedStateHelpDesk
      .filter((helpDesk) => helpDesk.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouHelpDesk', key: obj.key }
            : { role: 'hibouHelpDesk', key: defaultValue },
        { role: 'hibouHelpDesk', key: null }
      );

    checkedSuperAdministrator
      ? selectedRoles.push(
        {
          role: 'hibouDigitalContract',
          key: process.env.REACT_APP_ADMIN_DIGITAL_CONTRACT,
        },
        {
          role: 'hibouDigitalVault',
          key: process.env.REACT_APP_ADMIN_DIGITAL_VAULT,
        },
        {
          role: 'hibouHelpDesk',
          key: process.env.REACT_APP_HELPDESK_VALIDATOR,
        }
      )
      : selectedRoles.push(
        selectedContractId,
        selectedBovedaId,
        selectedHelpDeskId
      );

    let filteredNewRoles = [];

    for (let i = 0; i < checkedStateProfiles.length; i++) {
      if (
        checkedStateProfiles[i].id === checkedStateProfilesOrg[i].id &&
        checkedStateProfiles[i].checkedValue !==
        checkedStateProfilesOrg[i].checkedValue
      ) {
        filteredNewRoles.push(checkedStateProfiles[i]);
      }
    }

    /*Validacion para usuarios sin perfiles de firma; MR 21-06-2023 */
    let userExist;
    if (rolesByEmailUser.signaturerProfiles.length > 0) {
      userExist = rolesByEmailUser.signaturerProfiles.find(
        (item) => item.user.id
      ).userId;
    } else {
      userExist = rolesByEmailUser.userId;
    }
    const userId = userExist;

    const selectedProfiles = filteredNewRoles.map((newRole) => ({
      active: newRole.checkedValue,
      userId: userId,
      signatureProfileId: newRole.id,
    }));

    const body = {
      email: selectedUser.email,
      rolesIds: selectedRoles,
      signatureProfiles: selectedProfiles,
      emailAdmin: emailAdmin,
      firstName: selectedUser.firstName,
      firstLastName: selectedUser.firstLastName,
      secondLastName: selectedUser.secondLastName,
    };

    saveRolesAndProfilesForUser(token, body);
  };

  const isMobile = useMediaQuery('(max-width:560px');

  return (
    <div className='userAdministrationRoleAssignView-wrapper'>
      <>
        <header className='userAdministrationRoleAssignView-header'>
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== '' ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== '') ||
                selectedUser.secondLastName !== ''
                ? `${t('userAdministrationView.title.roles.to')} ${selectedUser.name
                }`
                : t('userAdministrationView.roleAssignTitle')
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            altCustomImg={'Empresa'}
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </header>
        <section className='userAdministrationRoleAssignView-body'>
          <div className='userAdministrationRoleAssignView-form'>
            <div style={{ display: 'inline-flex' }}>
              <CheckBoxHLPure
                labelCheckBox={t('userAdministrationView.super.administrator')}
                checkedState={checkedSuperAdministrator}
                onChangeHandler={(e) => handleCheckedSuperAdministrator(e)}
                tooltipShow
                titleTooltip={t('userAdministrationView.super.administrator')}
                descriptionTooltip={t(
                  'userAdministrationRoleAssign-superUserTooltip'
                )}
                positionTooltip={isMobile ? 'top' : 'right'}
                informationIcon
                idCheckBox={'Super administrador govo.digital'}
              />{' '}
            </div>
          </div>
          <div className='userAdministrationRoleAssignView-checks'>
            <div className='userAdministrationRoleAssignView-contract'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.digital.library')}</label>
                <TooltipHLPure
                  titleTooltip={t('userAdministrationView.digital.library')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-digitalLibraryTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                />
              </div>

              {checkedStateContrato &&
                checkedStateContrato.map((rolContrato, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolContrato.key}`, {
                        defaultValue: rolContrato.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolContrato.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleContratoCheckedState(rolContrato, e)
                      }
                      idCheckBox={rolContrato.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-boveda'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.digital.vault')}</label>
                <TooltipHLPure
                  titleTooltip={t('userAdministrationView.digital.vault')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-bovedaTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                />
              </div>
              {checkedStateBoveda &&
                checkedStateBoveda.map((rolBoveda, index) => {
                  return (
                    <CheckBoxHLPure
                      key={rolBoveda.key}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolBoveda.key}`, {
                        defaultValue: rolBoveda.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolBoveda.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleBovedaCheckedState(rolBoveda, e)
                      }
                      idCheckBox={rolBoveda.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-boveda'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('app.action.helpDesk')}</label>
                <TooltipHLPure
                  titleTooltip={t('app.action.helpDesk')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-helpDeskTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                />
              </div>
              {checkedStateHelpDesk &&
                checkedStateHelpDesk.map((rolHelpDesk, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolHelpDesk.key}`, {
                        defaultValue: rolHelpDesk.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolHelpDesk.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleHelpDeskCheckedState(rolHelpDesk, e)
                      }
                      idCheckBox={rolHelpDesk.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-profiles'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.signatures.profile')}</label>
                <TooltipHLPure
                  titleTooltip={'Asignar Perfiles'}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-profilesTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                />
              </div>
              {checkedStateProfiles &&
                checkedStateProfiles.length &&
                checkedStateProfiles.map((profile, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      labelCheckBox={profile.name}
                      checkedState={profile.checkedValue}
                      onChangeHandler={() => handleProfileCheckedState(index)}
                      idCheckBox={profile.id}
                    />
                  );
                })}
            </div>
          </div>
          <div className='userAdministrationRoleAssignView-btnGroup'>
            <div className='userAdministrationRoleAssignView-spaceBtns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </div>
            <ButtonHLPure
              primary
              nameBtn={t('button.save')}
              onClickBtn={handleSaveRolesAndProfilesData}
            />
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              showCompletedRequesting={showCompletedRequesting}
              showErrorRequesting={showErrorRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
              toggleCompletedRequesting={toggleCompleteCloseDialog}
              toggleErrorRequesting={toggleErrorRequesting}
              message={message}
            />
          </div>
        </section>
      </>
    </div>
  );
};

export default UserAdministrationRoleAssignView;
